<p>group-assignment works!</p>
